<h1 mat-dialog-title class="p-2 text-center">Nouveau substrat</h1>
<div class="p-3">

    <div mat-dialog-content class="row d-flex">

        <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Minéral Prélevé</mat-label>
                <mat-select placeholder="Minéral Prélevé" [(ngModel)]="model.MineralPreleve" required>
                    <mat-option *ngFor="let p of SubstratMineralList; let i = index" [value]="i + 1">
                        <span>{{p}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Minéral Accompagnant</mat-label>
                <mat-select placeholder="Minéral Accompagnant" [(ngModel)]="model.MineralAccompagnant" required>
                    <mat-option *ngFor="let p of SubstratMineralList; let i = index" [value]="i + 1">
                        <span>{{p}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Veg1</mat-label>
                <mat-select placeholder="Veg1" [(ngModel)]="model.Veg1">
                    <mat-option [value]='null'>Aucun</mat-option>
                    <mat-option *ngFor="let p of SubstratVegetalList; let i = index" [value]="i + 1">
                        <span>{{p}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Veg2</mat-label>
                <mat-select placeholder="Veg2" [(ngModel)]="model.Veg2">
                    <mat-option [value]='null'>Aucun</mat-option>
                    <mat-option *ngFor="let p of SubstratVegetalList; let i = index" [value]="i + 1">
                        <span>{{p}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
                <mat-label>Veg3</mat-label>
                <mat-select placeholder="Veg3" [(ngModel)]="model.Veg3">
                    <mat-option [value]='null'>Aucun</mat-option>
                    <mat-option *ngFor="let p of SubstratVegetalList; let i = index" [value]="i + 1">
                        <span>{{p}}</span>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <mat-form-field class="w-100">
            <mat-label>Recouvrement CHARLI (%)</mat-label>
            <input matInput placeholder="Recouvrement CHARLI (%)" type="number" [(ngModel)]="model.RecouvrementCharli">
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>Profondeur (m)</mat-label>
            <input matInput placeholder="Profondeur (m)" type="number" [(ngModel)]="model.Profondeur">
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>Distance Berge (m)</mat-label>
            <input matInput placeholder="Distance Berge (m)" type="number" [(ngModel)]="model.DistanceBerge">
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-label>Commentaire</mat-label>
            <input matInput placeholder="Commentaire" [(ngModel)]="model.Commentaire">
        </mat-form-field>

        <mat-slide-toggle class="col-12 col-md-6 col-xl-4 my-3" [(ngModel)]="model.CoherenceGPS">Cohérence GPS
        </mat-slide-toggle>

        <mat-form-field class="w-100" *ngIf="model.GPSPosition">
            <mat-label>X</mat-label>
            <input matInput placeholder="X" type="number" [(ngModel)]="model.GPSPosition.L93X" (keyup)="onKeyUpEventForGPSX($event)"
                   [formControl]="IsX2FarControl" [readonly]="model.CoherenceGPS">
            <mat-error *ngIf="IsX2FarControl.hasError('pattern')">
                Format erroné. 6 chiffres uniquement !
            </mat-error>
        </mat-form-field>
        <mat-form-field class="w-100" *ngIf="model.GPSPosition">
            <mat-label>Y</mat-label>
            <input matInput placeholder="Y" type="number" [(ngModel)]="model.GPSPosition.L93Y" (keyup)="onKeyUpEventForGPSY($event)"
                   [formControl]="IsY2FarControl" [readonly]="model.CoherenceGPS">
            <mat-error *ngIf="IsY2FarControl.hasError('pattern')">
                Format erroné. 7 chiffres uniquement !
            </mat-error>
        </mat-form-field>

    </div>

    <button appPreventDoubleClick class="col-6 squared-flat-button" color="primary" mat-stroked-button (throttledClick)="onCancel()">
        Annuler
    </button>
    <button appPreventDoubleClick class="col-6 squared-flat-button" color="warn" mat-stroked-button (throttledClick)="onConfirm()" [disabled]="!CanAdd">
        Sauvegarder
    </button>
</div>